import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import firebase from 'firebase/compat/app';
import constants from '../constants';
import { ALLOCATION } from '../models/allocation';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class AllocationService {

  constructor(private afs: AngularFirestore) { }

  getByDocId = (docId: string) => {
    return this.afs
      .collection(constants.FB_ALLOCATIONS)
      .doc(docId)
      .get();
  }

async getMemberAlloctions(memberDocId: string, limit = 0){
    let allocationsRef = firebase.firestore().collection('allocations')
    .where('member.memberDocId', '==', memberDocId).
      orderBy('transactionDate', 'desc');
    if (limit > 0) {
      allocationsRef = allocationsRef.limit(limit);
    }
    const allocationSnapshot = await allocationsRef.get();
    const allocations: any[] = [];

    if (!allocationSnapshot.empty) {
      allocationSnapshot.forEach((allo: any) => {
        const allocation = allo.data();
        allocation.docId = allo.id;
        allocations.push(allocation);
      });
    }
    return allocations;
  };

  async getSavings(){
    return  firebase.firestore()
    .collection(constants.FB_ALLOCATIONS)
    .where ('depositType', '==' , 'savings')
    .get();

  }
  async getHayaanAccount() {
    const accountRef = firebase.firestore()
    .collection('allocations')
    .doc('hayaan_account');

  const accountSnapshot=await accountRef.get();
  if(accountSnapshot.exists){
    return accountSnapshot.data()
  }
		return {}
	}


  allocationTransaction = async (allocation: ALLOCATION, fUser: firebase.User) => {

    // if (allocation.loanAmount > 0) {
    //   // const loansCollection = this.afs.collection(constants.FB_LOANS);
    //   // TODO:
    // }

    // if (allocation.registrationFee > 0) {
    //   const registrationFeesCollection = this.afs.collection(constants.FB_REGISTRATION_FEES);
    //   await registrationFeesCollection.add({
    //     memberDoc: allocation.member.memberDocId,
    //     memberNumber: allocation.member.memberNumber,
    //     amount: allocation.registrationFee,
    //     transactionDocId: allocation.transactionDocId,
    //     transactionDate: allocation.transactionDate,
    //     transactionReferenceNumber: allocation.transactionReferenceNumber,
    //     allocatedBy: { uid: fUser.uid, email: fUser.email },
    //     dateAllocated: firebase.firestore.FieldValue.serverTimestamp()
    //   });
    // }

    // if (allocation.savingsAmount > 0) {
    //   const savingsCollection = this.afs.collection(constants.FB_SAVINGS);
    //   await savingsCollection.add({
    //     memberDoc: allocation.member.,
    //     memberNumber: allocation.member.memberNumber,
    //     amount: allocation.savingsAmount,
    //     transactionDocId: allocation.transactionDocId,
    //     transactionDate: allocation.transactionDate,
    //     transactionReferenceNumber: allocation.transactionReferenceNumber,
    //     allocatedBy: { uid: fUser.uid, email: fUser.email },
    //     dateAllocated: firebase.firestore.FieldValue.serverTimestamp()
    //   });
    // }

    // if (allocation.registrationFee > 0) {
    //   const capitalCollection = this.afs.collection(constants.FB_CAPITAL_CONTRIBUTIONS);
    //   await capitalCollection.add({
    //     memberDoc: allocation.member.memberDocId,
    //     memberNumber: allocation.member.memberNumber,
    //     amount: allocation.shareCapital,
    //     transactionDocId: allocation.transactionDocId,
    //     transactionDate: allocation.transactionDate,
    //     transactionReferenceNumber: allocation.transactionReferenceNumber,
    //     allocatedBy: { uid: fUser.uid, email: fUser.email },
    //     dateAllocated: firebase.firestore.FieldValue.serverTimestamp()
    //   });
    // }

    // if (allocation.shareCapital > 0) {
    //   const registrationFeesCollection = this.afs.collection(constants.FB_REGISTRATION_FEES);
    //   await registrationFeesCollection.add({
    //     memberDoc: allocation.member.memberDocId,
    //     memberNumber: allocation.member.memberNumber,
    //     amount: allocation.registrationFee,
    //     transactionDocId: allocation.transactionDocId,
    //     transactionDate: allocation.transactionDate,
    //     transactionReferenceNumber: allocation.transactionReferenceNumber,
    //     allocatedBy: { uid: fUser.uid, email: fUser.email },
    //     dateAllocated: firebase.firestore.FieldValue.serverTimestamp()
    //   });
    // }
  }

  getAllocations({
    memberDocId = '',
    depositType = ''
  }: { memberDocId: string, depositType?: string }) {
    console.log("getAllocations service", memberDocId);
    return this.afs.collection(constants.FB_ALLOCATIONS, (ref: any) => {
      let query: firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
      query = query.where('member.memberDocId', '==', memberDocId);
      return query;
    }).snapshotChanges().pipe(
      map((actions: any) => {
        return actions.map((a: any) => {
          const allocation = a.payload.doc.data() as ALLOCATION;
          allocation.docId = a.payload.doc.id;
          console.log("allocation: ", allocation);
          return allocation;
        });
      })
    );
  }
}
